/* eslint-disable radix */
import React, { useState } from 'react';
import {
  lastDateOfMonth,
  startDateOfMonth,
} from 'pages/Dashboard/components/constant';
import { VENDOR_TYPES } from 'pages/Vendor/constants';
import { Card, CardBody, TabContent, TabPane } from 'reactstrap';
import CustomTabs from 'components/CustomTabs';
import SellerCommissionTable from './components/SellerCommissionTable';
import SellerCommissionCalendar from './components/SellerCommissionCalendar';

const SellerCommissionHistory = ({ sellerId }) => {
  const [activeTab, setActiveTab] = useState(VENDOR_TYPES.INDIAN);

  const [filters, setFilters] = useState({
    sellerId: parseInt(sellerId),
    fromDate: startDateOfMonth,
    toDate: lastDateOfMonth,
    currency: activeTab === VENDOR_TYPES.INDIAN ? 'INR' : 'USD',
  });
  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
    setFilters({
      ...filters,
      currency: tab === VENDOR_TYPES.INDIAN ? 'INR' : 'USD',
    });
  };

  return (
    <>
      {' '}
      <Card className="border-0 card-box page-card-box ">
        <CardBody>
          <CustomTabs
            tabs={[VENDOR_TYPES.INDIAN, VENDOR_TYPES.FOREIGN]}
            selectedTab={activeTab}
            onTabChange={toggle}
            className="mb-2"
          />
          <TabContent className="pt-2" activeTab={activeTab}>
            {activeTab === VENDOR_TYPES.INDIAN && (
              <TabPane tabId={VENDOR_TYPES.INDIAN}>
                <SellerCommissionCalendar
                  filters={filters}
                  setFilters={setFilters}
                />
                <SellerCommissionTable filters={filters} />
              </TabPane>
            )}
            {activeTab === VENDOR_TYPES.FOREIGN && (
              <TabPane tabId={VENDOR_TYPES.FOREIGN}>
                <SellerCommissionCalendar
                  filters={filters}
                  setFilters={setFilters}
                />
                <SellerCommissionTable filters={filters} />
              </TabPane>
            )}
          </TabContent>
        </CardBody>
      </Card>
    </>
  );
};

export default SellerCommissionHistory;
